<template>
  <div>

    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="Cash Receipts" name="cashReceipts">
        <cash-receipts ref="cashReceipts" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Deposits" name="deposits">
        <deposits ref="deposits" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Advances From" name="advancesFrom">
        <advances-from ref="advancesFrom" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Acknowledgement Receipts" name="acknowledgementReceipts">Current Service Under Development</el-tab-pane>
      <el-tab-pane label="Billable Expenses" name="billableExpenses">Current Service Under Development</el-tab-pane>
    </el-tabs>

  </div>
</template>

<script>
  import AdvancesFrom from '@/components/clients/aT/AdvancesFrom.vue'
  import Liquidations from '@/components/clients/aT/Liquidations.vue'
  import CashReceipts from '@/components/clients/aT/CashReceipts.vue'
  import Deposits from '@/components/clients/aT/Deposits.vue'

  export default {
    props: ['selectedRow'],
    components: {
      AdvancesFrom,
      Liquidations,
      CashReceipts,
      Deposits
    },
    data() {
      return {
        activeName: 'cashReceipts',
      }
    },
    methods: {
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
        // if (tab.name === 'advancesFrom') {
        //   this.$refs[tab.name].openTab()
        // } else if (tab.name === 'liquidations') {
        //   this.$refs[tab.name].openTab()
        // }
      },
      openTab() {
        this.activeName = 'cashReceipts'
        this.$refs['cashReceipts'].openTab()
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>